const DragDirective = {
  mounted(el: HTMLElement) {
    el.style.cursor = 'move';
    el.addEventListener('mousedown', (event: MouseEvent) => {
      event.preventDefault();
      el.style.position = 'absolute'; // 兜底
      // 计算当前 left/top
      const rect = el.getBoundingClientRect();
      const parent = el.parentElement;
      if (!parent) return;
      const parentRect = parent.getBoundingClientRect();
      // 同步当前视觉位置到 right/bottom
      el.style.right = `${parentRect.right - rect.right}px`;
      el.style.bottom = `${parentRect.bottom - rect.bottom}px`;
      el.style.left = 'auto';
      el.style.top = 'auto';
      // 拖拽基准
      const startX = event.clientX;
      const startY = event.clientY;
      const origRight = parseFloat(el.style.right);
      const origBottom = parseFloat(el.style.bottom);

      const mouseMoveHandler = (moveEvent: MouseEvent) => {
        moveEvent.preventDefault();
        const elWidth = el.offsetWidth;
        const elHeight = el.offsetHeight;
        const parentRect = parent.getBoundingClientRect();
        // 计算新的 right 和 bottom（相对父元素）
        let newRight = origRight - (moveEvent.clientX - startX);
        let newBottom = origBottom - (moveEvent.clientY - startY);
        // 边界判断（只能在父元素内拖拽）
        if (newRight < 0) newRight = 0;
        if (newBottom < 0) newBottom = 0;
        if (newRight > parentRect.width - elWidth) newRight = parentRect.width - elWidth;
        if (newBottom > parentRect.height - elHeight) newBottom = parentRect.height - elHeight;
        // 设置 right 和 bottom
        el.style.right = `${newRight}px`;
        el.style.bottom = `${newBottom}px`;
      };

      const mouseUpHandler = () => {
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    });
  },
  unmounted(el: HTMLElement) {
    el.removeEventListener('mousedown', () => {});
    document.removeEventListener('mousemove', () => {});
    document.removeEventListener('mouseup', () => {});
  },
};

export default DragDirective;
